<template>
  <div class="login mlogin">
    <app-header head-title="登录"></app-header>
    <div class="loginPart">
      <div class="banner">
        <div class="center">
          <div class="loginDiv" :class="{bigger:mobileLoginTab}">
            <div class="login-tab">
              <span
                class="accountLogin"
                :class="{active:!mobileLoginTab}"
                @click="mobileLoginTab=false"
              >账号密码登录</span>
              <span
                class="phoneLogin"
                :class="{active:mobileLoginTab}"
                @click="mobileLoginTab=true"
              >手机验证码登录</span>
            </div>
            <!-- 账号密码登录 -->
            <el-form
              ref="loginForm1"
              :model="loginForm1"
              :rules="loginRules"
              class="login-form"
              autocomplete="on"
              v-show="!mobileLoginTab"
            >
              <el-form-item class="loginName" prop="account" :class="{'active': blur01}">
                <div class="error-code error-code-form2" v-if="captchaErrorForm2">{{captchaErrorForm2}}</div>
                <span class="account-icon"></span>
                <el-input
                  @blur="blur1"
                  ref="account"
                  v-model.trim="loginForm1.account"
                  placeholder="邮箱 / 手机"
                  name="account"
                  autocomplete="on"
                  @focus="captchaErrorForm2=''"
                />
              </el-form-item>
              <el-form-item
                :class="{'active': blur02}"
                prop="password"
                class="loginPassword"
                style="margin-bottom:0"
              >
                <span class="password-icon"></span>
                <el-input
                  @blur="blur2"
                  :key="passwordType"
                  ref="password"
                  v-model.trim="loginForm1.password"
                  :type="passwordType"
                  placeholder="密码"
                  name="password"
                  autocomplete="on"
                  @keyup.enter.native="handleLogin"
                  maxlength="16"
                  @focus="accountPwdErrorMsg=''; captchaErrorForm2=''"
                />
              </el-form-item>
              <!-- <div class="m-login-form-check-code-div">
                <el-form-item prop="captcha" class="check-code2" :class="{'active': blur06}" :error="accountErrorMsg" ref="captcha">
                  <span class="code-icon"></span>
                  <el-input
                    @blur="blur6"
                    v-model.trim="loginForm1.captcha"
                    type="text"
                    placeholder="图形码"
                    name="captcha"
                    maxlength="6"
                    @focus="accountErrorMsg=''"
                  />
                </el-form-item>
                <img
                  ref="imgCodeLogin"
                  :src="!mobileLoginTab && varHost + 'uc/auth/login/captcha'"
                  @click="imgCodeRefreshByLogin()"
                  class="code-img"
                  alt="验证码"
                />
              </div> -->
            </el-form>
            <!-- 手机号登录 -->
            <el-form
              ref="loginForm2"
              :model="loginForm2"
              :rules="loginRules"
              class="login-form"
              autocomplete="on"
              v-show="mobileLoginTab"
            >
              <el-form-item prop="phoneNumber" :error="phoneErrorMsg" class="loginPhoneNumber" :class="{'active': blur03}">
                <div class="error-code" v-if="captchaError">{{ captchaError }}</div>
                <span class="phoneNumber-icon"></span>
                <el-input
                  @blur="blur3"
                  ref="phoneNumber"
                  v-model.number="loginForm2.phoneNumber"
                  placeholder="请输入手机号"
                  name="phoneNumber"
                  autocomplete="on"
                  @focus="phoneErrorMsg=''; captchaError=''"
                  minlength="11"
                  maxlength="11"
                />
              </el-form-item>
              <!-- <div class="check-code-div">
                <el-form-item prop="code" class="check-code" :class="{'active': blur04}" :error="codeErrorMsg" ref="code">
                  <span class="code-icon"></span>
                  <el-input
                    @blur="blur4"
                    v-model.trim="loginForm2.code"
                    type="text"
                    placeholder="图形码"
                    name="code"
                    maxlength="6"
                    @focus="codeErrorMsg=''"
                  />
                </el-form-item>
                <img
                  ref="imgCode"
                  :src="mobileLoginTab && varHost + 'uc/auth/mobile-login/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="验证码"
                />
              </div> -->
              <div id="check-phonecode-div" class="check-phonecode-div">
                <el-form-item
                  :class="{'active': blur05}"
                  class="phone-code"
                  prop="phoneCode"
                  style="margin-bottom:0"
                  :error="phoneLoginCodeErrorMsg"
                >
                  <span class="phoneCode-icon"></span>
                  <el-input
                    id="inputs"
                    @blur="blur5"
                    ref="phoneCode"
                    v-model.trim="loginForm2.phoneCode"
                    placeholder="验证码"
                    name="phoneCode"
                    @keyup.enter.native="handleLogin"
                    maxlength="6"
                    type="tel"
                    @focus="phoneLoginCodeErrorMsg=''; captchaError=''"
                  />
                  <el-button
                    :class="{'is-timing':able}"
                    type="primary"
                    class="codeBtn"
                    :disabled="able"
                    @click="checkPhonePrev"
                  >
                    <span v-show="show">获取验证码</span>
                    <span v-show="!show">{{count}} s</span>
                  </el-button>
                </el-form-item>
              </div>
            </el-form>
            <div class="commonLogin">
              <div class="autoLogin">
                <span class="autoLogin-btn">
                  <i class="icon" @click="autoLogin" ref="autologin"></i>下次自动登录
                </span>
                <span class="getBackPwd" @click="toGetBackPwd">找回密码</span>
              </div>
              <el-button
                :loading="loading"
                type="primary"
                class="loginBtn"
                @click.native.prevent="handleLogin"
              >登 录</el-button>
              <div class="toRegister">
                <span class="btn-toRegister" @click="toRegist">注册</span>
              </div>
              <div class="socialLoginIcon">
                <!-- <span class="wechat" @click="socialJump('wechat')"></span> -->
                <span class="weibo" @click="socialJump('weibo')"></span>
                <span class="qq" @click="socialJump('qq')"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
    <app-bind-phone :needBind="needBind" :needBindMobile="needBindMobile" @emitFn="emitFn"></app-bind-phone>
  </div>
</template>

<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import tipsBindPhone from "@/components/common/tipsBindPhone";
import { androidFontFn } from "@/utils/androidFont";

export default {
  name: "Login",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-bind-phone": tipsBindPhone
  },
  data() {
    const validPhoneNumber = (rule, value, callback) => {
      if (("" + value).length !== 11) {
        callback(new Error("手机号格式不正确"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {
      if (
        /^1[3456789]\d{9}$/.test(value) ||
        /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/.test(value)
      ) {
        callback();
      } else {
        callback(new Error("请输入手机号或邮箱号"));
      }
    };
    const validateCaptcha = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形验证码"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形验证码"));
      } else {
        callback();
      }
    };
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入短信验证码"));
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    return {
      captchaError: '',
      captchaErrorForm2: '',
      mobileLoginTab: false,
      codeErrorMsg: "",
      autoLoginBool: false,
      phoneErrorMsg: "",
      accountErrorMsg: "",
      accountPwdErrorMsg: "",
      phoneLoginCodeErrorMsg: "",
      loginForm1: {
        account: "",
        password: "",
        // captcha: '',
        remember: 0,
        captcha_result: {
          ticket: "",
          randstr: ""
        }
      },
      loginForm2: {
        phoneNumber: "",
        code: "",
        phoneCode: "",
        ticket: "",
        randstr: ""
      },
      loginRules: {
        account: [
          { required: true, trigger: "blur", validator: validateAccount }
        ],
        phoneNumber: [
          { required: true, trigger: "blur", validator: validPhoneNumber },
          { type: "number", message: "手机号必须为数字值", trigger: "blur" }
        ],
        password: [{ required: true, trigger: "blur", message: "请输入密码" }],
        captcha: [{ required: true, trigger: "blur", validator: validateCaptcha }],
        code: [{ required: true, trigger: "blur", validator: validateCode }],
        phoneCode: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ]
      },
      loading: false,
      passwordType: "password",
      show: true,
      count: "",
      timer: null,
      able: false,
      needBind: false,
      needBindMobile: false,
      blur01: false,
      blur02: false,
      blur03: false,
      blur04: false,
      blur05: false,
      blur06: false,
      CaptchaAppId: '192261687' // 198431980 192261687
    };
  },
  computed: {},
  watch: {},
  methods: {
    blur1(){
      this.blur01 = true
      this.blur02 = false
      this.blur03 = false
      this.blur04 = false
      this.blur05 = false
      this.blur06 = false
    },
    blur2(){
      this.blur02 = true
      this.blur01 = false
      this.blur03 = false
      this.blur04 = false
      this.blur05 = false
      this.blur06 = false
    },
    blur3(){
      this.blur03 = true
      this.blur01 = false
      this.blur02 = false
      this.blur04 = false
      this.blur05 = false
      this.blur06 = false
    },
    blur4(){
      this.blur04 = true
      this.blur01 = false
      this.blur02 = false
      this.blur03 = false
      this.blur05 = false
      this.blur06 = false
    },
    blur5(){
      this.blur05 = true
      this.blur01 = false
      this.blur02 = false
      this.blur03 = false
      this.blur04 = false
      this.blur06 = false
    },
    blur6(){
      this.blur06 = true
      this.blur05 = false
      this.blur01 = false
      this.blur02 = false
      this.blur03 = false
      this.blur04 = false
    },
    emitFn(bool) {
      this.needBind = bool;
      this.needBindMobile = bool;
    },
    checkLoginState() {
      user
        .getUserInfo()
        .then(result => {
          //自动跳转
          // this.$router.replace({ name: "index" });
          location.href = "https://m.huanqiu.com";
        })
        .catch(err => {
          console.log(err);
          if (err.status == 403) {
            if (err.data.message === "社交账号登录，未绑定手机号") {
              this.needBind = true;
            } else if (err.data.message === "未绑定手机号") {
              this.needBindMobile = true;
            }
          }
        });
    },
    socialJump(where) {
      window.location.href = this.varHost + "uc/auth/socialite/" + where;
    },
    // imgCodeRefreshByLogin() {
    //   this.$refs.imgCodeLogin.src =
    //     this.varHost + "uc/auth/login/captcha?" + Math.random();
    // },
    // imgCodeRefresh() {
    //   this.$refs.imgCode.src =
    //     this.varHost + "uc/auth/mobile-login/captcha?" + Math.random();
    // },
    checkPhonePrev(){
      let _this = this;
      this.$refs["loginForm2"].validateField("phoneNumber", error => {
        if (error) {
          return;
        } else {
          _this.getTcaptcha();
        }
      });      
    }, 
    checkPhone() {
      // this.$refs["loginForm2"].validateField("phoneNumber", error => {
      //   if (error) {
      //     return false;
      //   } else {
      //     this.$refs["loginForm2"].validateField("code", error => {
      //       if (error) {
      //         return false;
      //       } else {
      //         this.getCode();
      //       }
      //     });
      //   }
      // });
      this.getCode();
    },
    getCode() {
      // 发送请求获取验证码
      user
        .getMsgNewLogin({
          mobile: this.loginForm2.phoneNumber,
          captcha_result: {
            randstr: this.loginForm2.randstr,
            ticket: this.loginForm2.ticket
          }
        })
        .then(response => {
          this.lockGetCode();
        })
        .catch(error => {
          this.errorMsgEmpty();
          // this.imgCodeRefresh();
          // accountPwdErrorMsg
          this.$nextTick(function() {
            if (typeof error == "string") {
              if(error === '验证码验证失败'){
                this.captchaError = error
              }else if (error == "手机号不存在") {
                this.blur03 = true
                this.blur04 = false
                this.blur05 = false
                this.phoneErrorMsg = error;
                this.loginForm2.code = "";
              } else {
                this.blur03 = false
                this.blur04 = true
                this.blur05 = false
                this.codeErrorMsg = error;
                this.loginForm2.code = "";
              }
            }
            
          });
          // this.$refs["code"].resetField();
        });
      // this.imgCodeRefresh();
    },
    lockGetCode() {
      this.able = true;
      // 倒计时
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },

    loginFormPrev() {
      this.loading = true;
      this.autoLoginBool
        ? (this.loginForm1.remember = 1)
        : (this.loginForm1.remember = 0);
      user
        .pwdLogin(this.loginForm1)
        .then(res => {
          this.loading = false;
          if (res.data.redirect) {
            location.href = res.data.redirect;
          } else {
            location.href = "https://m.huanqiu.com";
            // this.$router.replace({ path: "/index" });
          }
        })
        .catch(error => {
          // this.imgCodeRefreshByLogin()
          this.loading = false;
          this.errorMsgEmpty();
          if (error.data && error.data.message === "未绑定手机号") {
            this.needBindMobile = true;
          }
          this.$nextTick(function() {
            // typeof error == "string"
            //   ? this.accountErrorMsg = error
            //   : true;

            if (typeof error == "string") {
              if(error === '验证码验证失败') {
                this.captchaErrorForm2 = error
              } else {
                this.accountErrorMsg = error
              }

              if(error === '用户名或密码错误'){
                this.captchaErrorForm2 = error
              }
            }
          });
        });
    },
    handleLogin() {
      if (!this.mobileLoginTab) {
        this.$refs.loginForm1.validate(valid => {
          if (valid) {
            this.getTcaptcha();
            // this.loading = true;
            // this.autoLoginBool
            //   ? (this.loginForm1.remember = 1)
            //   : (this.loginForm1.remember = 0);
            // user
            //   .pwdLogin(this.loginForm1)
            //   .then(res => {
            //     this.loading = false;
            //     if (res.data.redirect) {
            //       location.href = res.data.redirect;
            //     } else {
            //       location.href = "https://m.huanqiu.com";
            //       // this.$router.replace({ path: "/index" });
            //     }
            //   })
            //   .catch(error => {
            //     this.imgCodeRefreshByLogin()
            //     this.loading = false;
            //     console.log(error);
            //     this.errorMsgEmpty();
            //     if (error.data && error.data.message === "未绑定手机号") {
            //       this.needBindMobile = true;
            //     }
            //     this.$nextTick(function() {
            //       typeof error == "string"
            //         ? this.accountErrorMsg = error
            //         : true;
            //     });
            //   });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.$refs.loginForm2.validate(valid => {
          if (valid) {
            this.loading = true;
            user
              .msgLogin({
                mobile: this.loginForm2.phoneNumber,
                mobile_verify_code: this.loginForm2.phoneCode
              })
              .then(res => {
                this.loading = false;
                if (res.data.redirect) {
                  location.href = res.data.redirect;
                } else {
                  location.href = "https://m.huanqiu.com"
                  // this.$router.replace({ path: "/index" });
                }
              })
              .catch(error => {
                this.loading = false;
                this.errorMsgEmpty();
                this.$nextTick(function() {
                  typeof error == "string"
                    ? (this.phoneLoginCodeErrorMsg = error)
                    : true;
                });
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    autoLogin() {
      if (this.autoLoginBool) {
        this.$refs.autologin.style.backgroundPosition = "-49px -19px";
        this.autoLoginBool = false;
      } else {
        this.$refs.autologin.style.backgroundPosition = "-19px -19px";
        this.autoLoginBool = true;
      }
    },
    errorMsgEmpty() {
      this.captchaError = ''
      this.captchaErrorForm2 = ''
      this.codeErrorMsg = "";
      this.phoneErrorMsg = "";
      this.accountPwdErrorMsg = "";
      this.accountErrorMsg = "";
      this.phoneLoginCodeErrorMsg = "";
    },
    toRegist() {
      this.$router.push({ path: "/mregister" });
    },
    toGetBackPwd() {
      this.$router.push({ path: "/mresetPassword" });
    },
    getTcaptcha() {
      let _this = this;
      try {
        // 生成一个验证码对象
        let captcha = new TencentCaptcha(this.CaptchaAppId, _this.callback, {});
        // 调用方法，显示验证码
        captcha.show();
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        this.loadErrorCallback();
      }
    },
    callback(res) {
      // console.log('callback:', res);
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      if (res.ret === 0) {
        // 验证成功
        if(!this.mobileLoginTab){
          this.loginForm1.captcha_result.ticket = res.ticket;
          this.loginForm1.captcha_result.randstr = res.randstr;
          this.loginFormPrev();
        }else {
          this.loginForm2.ticket = res.ticket;
          this.loginForm2.randstr = res.randstr;
          this.checkPhone();
        }
      }else if(res.ret === 2){
        this.loginForm1.captcha_result.ticket = '';
        this.loginForm1.captcha_result.randstr = '';
        this.loginForm2.ticket = '';
        this.loginForm2.randstr = '';
      }
    },
    loadErrorCallback() {
        let appid = this.CaptchaAppId;
        // 生成容灾票据或自行做其它处理
        let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
        this.callback({
          ret: -1,
          randstr: '@' + Math.random().toString(36).substr(2),
          ticket: ticket,
          errorCode: 1001,
          errorMessage: 'jsload_error'
        });
    }
  },
  created() {
    this.checkLoginState();
  },
  mounted() {
    document.getElementById('check-phonecode-div') && document.getElementById('check-phonecode-div').addEventListener("mousedown", function(e){
      if(e.target['id'].indexOf('inputs') != 0){
        e.preventDefault()
      }
    }, false);
    androidFontFn();
  }
};
</script>

<style lang="scss">
// $bg: #283443;
// $light_gray: #fff;
// $cursor: #fff;

/* reset element-ui css */
html,
body {
  width: 100%;
  height: 100%;
  #app {
    height: 100%;
  }
}

.login {
  padding-bottom: 50px;
  .el-input {
    display: inline-block;
    height: 42px;
    width: 318px;
    input {
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      // color: $light_gray;
      height: 42px;
      // caret-color: $cursor;
    }
  }

  .el-form-item {
    margin-bottom: 18px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    color: #454545;
  }
  .m-login-form-check-code-div {
    width: 100%;
    position: relative;
    .check-code {
      width: 100%;
      .el-input {
        width: 100%;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 4px;
    }
  }
  .check-code-div {
    width: 210px;
    position: relative;
    .check-code {
      width: 210px;
      .el-input {
        width: 208px;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 4px;
    }
  }
  .check-phonecode-div {
    width: 100%;
    position: relative;
    .el-input {
      width: 100%;
    }
    .el-button.codeBtn {
      width: 90px;
      height: 30px;
      position: absolute;
      right: 7px;
      top: 7px;
      padding: 0;
    }
  }
  .el-form-item.active .el-form-item__content .el-form-item__error{
    z-index: 1000;
    background: #f3f2f0;
    padding-bottom: 2px;
  }
}
.login.mlogin{
  .el-form-item .el-input__inner{
    padding-top: 0!important;
    padding-bottom: 0!important;
    line-height: 43px!important;
  }
  input::-webkit-input-placeholder{
    font-size: 16px;
    line-height: 43px;
  }    
  input:-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                
  input::-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                  
  input:-ms-input-placeholder{
    line-height: 43px;
    font-size: 16px;
  }          
}

</style>

<style lang="scss" scoped>

// $bg: #2d3a4b;
// $dark_gray: #889aa4;
// $light_gray: #eee;

.loginName >>> .el-form-item__error {
  position: absolute;
  left: 0;
  // top: 135px;
  top: 96px;
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.loginPassword >>> .el-form-item__error {
  width: 100%;
  background: #f5f5f5;
  text-align: left;
  position: absolute;
  left: 0;
  // top: 90px;
  top: 50px;
  width: 100%;
}

.check-code2 >>> .el-form-item__error {
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.loginPhoneNumber >>> .el-form-item__error {
  width: 100%;
  background: #f5f5f5;
  text-align: left;
  position: absolute;
  left: 0;
  top: 91px;
  // top: 135px;
}

.check-code >>> .el-form-item__error {
  width: 100%;
  background: #f5f5f5;
  text-align: left;
  position: absolute;
  left: 0;
  top: 90px;
}

.check-phonecode-div >>> .el-form-item__error {
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.tipsBindPhone {
  margin: 0 auto;
}

#app .tipsBindPhone >>> .center-form {
  width: 90% !important;
  padding: 0 40px !important;
  box-sizing: border-box;
  left: 5% !important;
  margin-left: 0 !important;
  margin: 0 auto;
  z-index: 100;
  .bindPhone {
    .el-form-item__error {
      position: absolute;
      left: 0;
      top: 85px;
      width: 100%;
      background: #fff;
      text-align: left;
    }
  }
  .tips-title {
    margin-top: 40px !important;
    .title-big {
      font-size: 20px;
    }
    .title-small {
      font-size: 11px;
      text-align: left;
    }
  }
  .bindPhone-form {
    .el-input {
      width: 100% !important;
      input.el-input__inner {
        height: 45px !important;
        line-height: 45px !important;
        padding: 12px 5px 12px 15px;
      }
    }
    .check-phonecode-div {
      margin-top: 0 !important;
      width: 100% !important;
      .el-input {
        width: 100% !important;
      }
      .el-button.codeBtn {
        right: 7px;
        top: 7px;
        width: 90px;
        height: 30px;
      }
      .el-form-item__error {
        position: absolute;
        left: 0;
        top: 45px;
        width: 100%;
        background: #fff;
        text-align: left;
      }
    }
    .el-button.submitBtn {
      width: 100%;
      height: 45px;
      margin-top: 31px;
    }
  }
}

.footer {
  display: none;
}
.headerOuter {
  display: none;
}
.login >>> .el-input__inner {
  padding: 12px 5px 12px 54px;
  height: 45px;
  border-radius: 3px;
}

.login >>> .check-code-div {
  width: 100%;
  position: relative;
}

.login >>> .login-form-check-code-div {
  width: 100%;
  position: relative;
}
.login >>> .check-code {
  width: 100%;
  .el-input {
    width: 100%;
  }
}

.login >>> .code-img {
  width: 100px;
  height: 36px;
  position: absolute;
  right: 7px;
  top: 4px;
}

.login {
  width: 100%;
  height: 100%;
  background: #f5f5f5 url("../../assets/images/mlogin.png") no-repeat top center;
  background-size: 100%;
  overflow: hidden;
  padding-top: 35px;

  >>> .el-form-item {
    margin-bottom: 0;
    border: 0;
    border-radius: unset;
    color: #454545;
    >>> .el-input__inner {
      border: 1px solid #e8e8e8 !important;
      font-size: 14px !important;
    }
  }

  .el-input {
    display: inline-block;
    height: 45px;
    width: 100%;
    >>> input[name="account"] {
      border-radius: 6px 6px 0 0;
      // border-bottom: 1px solid #e8e8e8 !important;
    }

    >>> input[name="phoneNumber"] {
      border-radius: 6px 6px 0 0;
    }
    >>> input[name="captcha"] {
      border-radius: 0 0 6px 6px ;
      border-top: 0 !important;
    }
    >>> input[name="code"] {
      border-radius: 0;
      border-top: 0 !important;
      border-bottom: 0 !important;
    }

    >>> input[name="phoneCode"] {
      border-radius: 0 0 6px 6px;
    }

    >>> input[name="password"] {
      border-top: 0 !important;
      border-radius: 0 0 0 0;
    }
    
    >>> input[name="pwCode"] {
      border-top: 0 !important;
      border-radius: 0 0 6px 6px;
    }

  }
  .account-icon,
  .password-icon,
  .phoneNumber-icon,
  .code-icon,
  .phoneCode-icon {
    position: absolute;
    left: 20px;
    top: 3px;
    width: 18px;
    height: 39px;
    z-index: 1;
    background: url("../../assets/images/mlogin1.png") no-repeat center;
    background-size: 100%;
  }
  .password-icon {
    background: url("../../assets/images/mlogin2.png") no-repeat center;
    background-size: 100%;
  }
  .phoneNumber-icon {
    background: url("../../assets/images/mlogin1.png") no-repeat center;
    background-size: 100%;
  }
  .code-icon {
    background: url("../../assets/images/mlogin2.png") no-repeat center;
    background-size: 100%;
  }
  .phoneCode-icon {
    background: url("../../assets/images/mlogin2.png") no-repeat center;
    background-size: 100%;
  }
  .loginPart {
    margin-top: 0;
    margin-bottom: 0;
    height: 100%;
    width: 100%;
    .center {
      height: 100%;
      text-align: center;
      position: relative;
      width: 100%;
      margin: 0 auto;
    }
    .loginDiv {
      box-shadow: 0 1px 50px 0 #dfd3c2;
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 10px;
      position: absolute;
      right: 0;
      top: 77px;
      .login-tab {
        height: 45px;
        line-height: 45px;
        border-bottom: 1px solid #cccccc;
        span {
          display: inline-block;
          color: #999;
          height: 40px;
          width: 100px;
          font-size: 14px;
          margin: 0 15px;
          //margin-top: 8px;
          line-height: 40px;
          position: relative;
          cursor: pointer;
        }
        span.active {
          color: #595959;
          &::after {
            content: "";
            display: block;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            height: 3px;
            background-color: #f44533;
          }
        }
      }
    }
    .loginDiv.bigger {
      height: 100%;
      top: 77px;
    }
  }
  .login-form {
    position: relative;
    max-width: 100%;
    padding: 24px 30px 31px;
    margin: 0 auto;
    overflow: hidden;
  }
  .commonLogin {
    padding: 0 30px;
  }
  .autoLogin {
    font-size: 14px;
    height: 30px;
    cursor: pointer;
    .autoLogin-btn {
      float: left;
      color: #595959;
      .icon {
        width: 16px;
        height: 16px;
        float: left;
        margin-right: 6px;
        background: url("../../assets/images/icons.png") no-repeat -49px -19px;
      }
    }
    .getBackPwd {
      float: right;
      color: #4981f2;
    }
  }
  .toRegister {
    text-align: right;
    margin-top: 20px;
    margin-bottom: 45px;
    .btn-toRegister {
      color: #2b7ff7;
      cursor: pointer;
      font-size: 14px;
    }
  }
  .loginBtn {
    font-size: 21px;
    width: 100%;
    margin-bottom: 8px;
    color: #ffffff;
    font-family: Microsoft YaHei;
    word-spacing: 10px;
    border-radius: 6px;
    background: #2b7ff7 !important;
    box-shadow: inset 0px -8px 0px 0 #3f79ee, 0px 6px 0px 0 #e5e5e5 !important;
  }
  .socialLoginIcon {
    margin-top: 4px;
    text-align: center;
    height: 50px;
    font-size: 0;
    span {
      margin: 0 14px;
      width: 35px;
      height: 35px;
      display: inline-block;
      cursor: pointer;
    }
    .wechat {
      background: url("../../assets/images/m-wx.png") no-repeat center;
      background-size: 100%;
    }
    .weibo {
      background: url("../../assets/images/m-wb.png") no-repeat center;
      background-size: 100%;
    }
    .qq {
      background: url("../../assets/images/m-qq.png") no-repeat center;
      background-size: 100%;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    // color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
  .error-code, .error-code-form2 {
    font-size: 12px;
    position: absolute;
    z-index: 100;
    color: #f00;
    top: 91px;
    width: 100%;
    background: #f5f5f5;
    line-height: 18px;
    text-align: left;
  }
  .error-code-form2 {
    top: 96px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mlogin/index.vue